import React from 'react';
import styled from 'styled-components';
import EllipsesControl from '../EllipsesControl/EllipsesControl';
import {getInUserNumberFormat} from '../Accounts/AccountSummary/AccountSummaryConfig';
import {useUserPreferences} from '../../../util/customHooks';
import {isNullOrUndefined} from '../../../util/utils';

export default function NumberColumn(params) {
	const userPreferences = useUserPreferences();
	const numberFormated = getInUserNumberFormat(params.value, userPreferences);

	return (
		<StyledNumberColumn className="StyledNumberColumn">
			{!isNullOrUndefined(params.value) ? (
				<span className="text-renderer">
					<EllipsesControl noOfLines={1} content={numberFormated} tooltip={numberFormated} />
				</span>
			) : (
				<span className="noDataDash">{'-'}</span>
			)}
		</StyledNumberColumn>
	);
}

const StyledNumberColumn = styled.section`
	display: flex;
	justify-content: flex-end;
	font-size: var(--px-12);
	font-weight: 400;
	line-height: var(--px-22);
	.text-renderer {
		font-size: var(--px-12);
		font-weight: 400;
		width: auto;
		max-width: 90%;
	}
`;
